var map = {
	"./AdGuardDnsInfo.vue": [
		65402,
		[
			4314,
			5402
		]
	],
	"./AdGuardFilterStatus.vue": [
		40486,
		[
			4314,
			486
		]
	],
	"./AdGuardStats.vue": [
		71799,
		[
			4391,
			1799
		]
	],
	"./AdGuardTopDomains.vue": [
		84583,
		[
			4583
		]
	],
	"./AnonAddy.vue": [
		11924,
		[
			4314,
			1924
		]
	],
	"./Apod.vue": [
		65354,
		[
			5354
		]
	],
	"./BlacklistCheck.vue": [
		16447,
		[
			6447
		]
	],
	"./Blank.vue": [
		37693,
		[
			7693
		]
	],
	"./ChuckNorris.vue": [
		18155,
		[
			8155
		]
	],
	"./Clock.vue": [
		368,
		[
			368
		]
	],
	"./CodeStats.vue": [
		95565,
		[
			4314,
			4391,
			5565
		]
	],
	"./CovidStats.vue": [
		20153,
		[
			4314,
			4391,
			153
		]
	],
	"./CryptoPriceChart.vue": [
		90378,
		[
			4391,
			378
		]
	],
	"./CryptoWatchList.vue": [
		66258,
		[
			4314,
			6258
		]
	],
	"./CustomList.vue": [
		52930,
		[
			2930
		]
	],
	"./CustomSearch.vue": [
		86053,
		[
			6053
		]
	],
	"./CveVulnerabilities.vue": [
		94023,
		[
			4314,
			4023
		]
	],
	"./DomainMonitor.vue": [
		74514,
		[
			4314,
			4514
		]
	],
	"./DroneCi.vue": [
		52473,
		[
			4314,
			2473
		]
	],
	"./EmbedWidget.vue": [
		23651,
		[
			3651
		]
	],
	"./EthGasPrices.vue": [
		22827,
		[
			4314,
			4391,
			2827
		]
	],
	"./ExchangeRates.vue": [
		15286,
		[
			4314,
			5286
		]
	],
	"./Filebrowser.vue": [
		41438,
		[
			4314,
			1438
		]
	],
	"./Flights.vue": [
		94766,
		[
			4766
		]
	],
	"./GitHubProfile.vue": [
		46265,
		[
			6265
		]
	],
	"./GitHubTrending.vue": [
		17762,
		[
			4314,
			7762
		]
	],
	"./GlAlerts.vue": [
		71316,
		[
			4314,
			1316
		]
	],
	"./GlCpuCores.vue": [
		97975,
		[
			4314,
			7975
		]
	],
	"./GlCpuGauge.vue": [
		88380,
		[
			4314,
			8380
		]
	],
	"./GlCpuHistory.vue": [
		76586,
		[
			4314,
			4391,
			6586
		]
	],
	"./GlCpuSpeedometer.vue": [
		82501,
		[
			4314,
			2501
		]
	],
	"./GlCpuTemp.vue": [
		74478,
		[
			4314,
			4478
		]
	],
	"./GlDiskIo.vue": [
		88738,
		[
			4314,
			8738
		]
	],
	"./GlDiskSpace.vue": [
		58402,
		[
			4314,
			8402
		]
	],
	"./GlIpAddress.vue": [
		12675,
		[
			2675
		]
	],
	"./GlLoadHistory.vue": [
		75398,
		[
			4314,
			4391,
			5398
		]
	],
	"./GlMemGauge.vue": [
		11270,
		[
			4314,
			1270
		]
	],
	"./GlMemHistory.vue": [
		64334,
		[
			4314,
			4391,
			4334
		]
	],
	"./GlMemSpeedometer.vue": [
		666,
		[
			4314,
			666
		]
	],
	"./GlNetworkInterfaces.vue": [
		7838,
		[
			4314,
			7838
		]
	],
	"./GlNetworkTraffic.vue": [
		90489,
		[
			4314,
			4391,
			489
		]
	],
	"./GlSystemLoad.vue": [
		14191,
		[
			4391,
			4191
		]
	],
	"./GluetunStatus.vue": [
		633,
		[
			633
		]
	],
	"./HackernewsTrending.vue": [
		8440,
		[
			8440
		]
	],
	"./HealthChecks.vue": [
		29707,
		[
			4314,
			9707
		]
	],
	"./IframeWidget.vue": [
		27923,
		[
			7923
		]
	],
	"./ImageWidget.vue": [
		21419,
		[
			1419
		]
	],
	"./Jokes.vue": [
		71854,
		[
			1854
		]
	],
	"./Linkding.vue": [
		2169,
		[
			2169
		]
	],
	"./MullvadStatus.vue": [
		58569,
		[
			8569
		]
	],
	"./Mvg.vue": [
		96414,
		[
			4314,
			6414
		]
	],
	"./MvgConnection.vue": [
		83849,
		[
			3849
		]
	],
	"./NdCpuHistory.vue": [
		78958,
		[
			4391,
			8958
		]
	],
	"./NdLoadHistory.vue": [
		9405,
		[
			4391,
			9405
		]
	],
	"./NdRamHistory.vue": [
		11556,
		[
			4391,
			1556
		]
	],
	"./NewsHeadlines.vue": [
		50811,
		[
			4314,
			811
		]
	],
	"./NextcloudNotifications.vue": [
		23199,
		[
			4314,
			3199
		]
	],
	"./NextcloudPhpOpcache.vue": [
		27991,
		[
			4314,
			7991
		]
	],
	"./NextcloudStats.vue": [
		16952,
		[
			4314,
			6952
		]
	],
	"./NextcloudSystem.vue": [
		97627,
		[
			4314,
			4391,
			7627
		]
	],
	"./NextcloudUser.vue": [
		29341,
		[
			4314,
			9341
		]
	],
	"./NextcloudUserStatus.vue": [
		10048,
		[
			4314,
			48
		]
	],
	"./PiHoleStats.vue": [
		55623,
		[
			5623
		]
	],
	"./PiHoleStatsV6.vue": [
		95511,
		[
			4314,
			4391,
			5511
		]
	],
	"./PiHoleTopQueries.vue": [
		17768,
		[
			4314,
			7768
		]
	],
	"./PiHoleTopQueriesV6.vue": [
		38786,
		[
			4314,
			8786
		]
	],
	"./PiHoleTraffic.vue": [
		58321,
		[
			4391,
			8321
		]
	],
	"./PiHoleTrafficV6.vue": [
		34680,
		[
			4391,
			4680
		]
	],
	"./Proxmox.vue": [
		18922,
		[
			8922
		]
	],
	"./PublicHolidays.vue": [
		35832,
		[
			4314,
			5832
		]
	],
	"./PublicIp.vue": [
		9161,
		[
			4314,
			9161
		]
	],
	"./RescueTime.vue": [
		89788,
		[
			9788
		]
	],
	"./RssFeed.vue": [
		66745,
		[
			6745
		]
	],
	"./Sabnzbd.vue": [
		9989,
		[
			9989
		]
	],
	"./SportsScores.vue": [
		40702,
		[
			4314,
			702
		]
	],
	"./StatPing.vue": [
		80667,
		[
			4314,
			667
		]
	],
	"./StockPriceChart.vue": [
		76231,
		[
			4391,
			6231
		]
	],
	"./SynologyDownload.vue": [
		73255,
		[
			4314,
			3255
		]
	],
	"./SystemInfo.vue": [
		83896,
		[
			4391,
			3896
		]
	],
	"./TacticalRMM.vue": [
		73720,
		[
			3720
		]
	],
	"./TflStatus.vue": [
		54045,
		[
			4045
		]
	],
	"./UptimeKuma.vue": [
		83330,
		[
			3330
		]
	],
	"./WalletBalance.vue": [
		80509,
		[
			4314,
			509
		]
	],
	"./Weather.vue": [
		96695,
		[
			6695
		]
	],
	"./WeatherForecast.vue": [
		86026,
		[
			4314,
			6026
		]
	],
	"./WidgetBase.vue": [
		97122,
		[]
	],
	"./XkcdComic.vue": [
		66197,
		[
			6197
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42625;
module.exports = webpackAsyncContext;